import {
  failureProfitabilityGrossRevenueGraph,
  responseProfitabilityGrossRevenueGraph,
  requestProfitabilityGrossRevenueGraph,
} from 'reactRedux/slices/profitabilityAnalysisSlice/ProfitabilityAnalysisSlice';
import Swal from 'sweetalert2';
import requestApi from 'utils/Request';
import { PROFITABILITY_GROSS_REVENUE } from 'utils/StaticApiEndpoints';

export const ProfitabilityAnalysisGrossRevenue =
  (payload, callback) => async (dispatch) => {
    try {
      dispatch(requestProfitabilityGrossRevenueGraph());
      const res = await requestApi.get(PROFITABILITY_GROSS_REVENUE, {
        params: payload,
      });
      dispatch(responseProfitabilityGrossRevenueGraph(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureProfitabilityGrossRevenueGraph(error?.message));
    }
  };
